import globalTheme, { muiTheme } from '../global'

const CssBaseline = {
	MuiCssBaseline: {
		styleOverrides: {
			':root': {
				colorScheme: 'light dark',
				// spacing
				'--spacing': globalTheme.spacing(1),
				'--spacing-1': 'calc(var(--spacing) * 1)',
				'--spacing-2': 'calc(var(--spacing) * 2)',
				'--spacing-3': 'calc(var(--spacing) * 3)',
				'--spacing-4': 'calc(var(--spacing) * 4)',
				'--spacing-5': 'calc(var(--spacing) * 5)',
				'--spacing-6': 'calc(var(--spacing) * 6)',
				'--spacing-7': 'calc(var(--spacing) * 7)',
				'--spacing-8': 'calc(var(--spacing) * 8)',
				'--spacing-9': 'calc(var(--spacing) * 9)',
				'--spacing-10': 'calc(var(--spacing) * 10)',
				// colors
				// theme colors
				'--color-primary': globalTheme.palette.primary.main,
				'--color-primary-contrast': globalTheme.palette.primary.contrastText,
				'--color-secondary': globalTheme.palette.secondary.main,
				'--color-secondary-contrast': globalTheme.palette.secondary.contrastText,
				'--color-error': globalTheme.palette.error.main,
				'--color-error-contrast': globalTheme.palette.error.contrastText,
				'--color-warning': globalTheme.palette.warning.main,
				'--color-warning-contrast': globalTheme.palette.warning.contrastText,
				'--color-info': globalTheme.palette.info.main,
				'--color-info-contrast': globalTheme.palette.info.contrastText,
				'--color-success': globalTheme.palette.success.main,
				'--color-success-contrast': globalTheme.palette.success.contrastText,
				'--color-border': globalTheme.palette.divider,
				// custom colors
				'--color-white': globalTheme.palette.common.white,
				'--color-black': globalTheme.palette.common.black,
				'--color-brand': '#015cff',
				'--color-brand-contrast': '#ffffff',
				// shape
				'--border-radius': globalTheme.shape.borderRadius + 'px',
				// animations
				'--transition-duration': globalTheme.transitions.duration.standard + 'ms',
				'--transition-timing-function': globalTheme.transitions.easing.easeInOut,
				'--transition': 'var(--transition-duration) var(--transition-timing-function)',
				// accessibility
				'--accessibility-focus-color': '#5E9ED6',
				'--accessibility-focus-style': 'solid',
				'--accessibility-focus-width': '2px',
				'--accessibility-focus-outline':
					'var(--accessibility-focus-color) var(--accessibility-focus-style) var(--accessibility-focus-width)',
				// scroll padding
				'--scroll-padding': 'var(--spacing-2)',
			},
			':focus': {
				outline: 'none',
			},
			':focus-visible': {
				outline: 'var(--accessibility-focus-outline) !important',
			},
			MuiCssBaseline: {
				// styleOverrides: `
				//   @font-face {
				//     font-family: 'Raleway';
				//     font-style: normal;
				//     font-display: swap;
				//     font-weight: 400;
				//     src: "local('Raleway'), local('Raleway-Regular'), url(${RalewayWoff2}) format('woff2')";
				//     unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
				//   }
				// `,
			},
			html: {
				WebkitFontSmoothing: 'auto',
				fontSize: muiTheme.typography.htmlFontSize,
				height: '100%',
			},
			body: {
				color: globalTheme.palette.common.black,
				fontFamily: globalTheme.typography.body1.fontFamily,
				fontSize: globalTheme.typography.fontSize,
				lineHeight: 1.25,
				height: '100%',
				'& .grecaptcha-badge': { visibility: 'hidden' },
				[globalTheme.breakpoints.down('sm')]: {
					overflowY: 'overlay',
				},
				'& .d-none': {
					display: 'none !important',
				},
				'& .d-none-xs': {
					[globalTheme.breakpoints.down('xsm')]: {
						display: 'none !important',
					},
				},
				'& .d-none-xsm': {
					[globalTheme.breakpoints.down('sm')]: {
						display: 'none !important',
					},
				},
				'& .d-none-sm': {
					[globalTheme.breakpoints.down('md')]: {
						display: 'none !important',
					},
				},
				'& .d-none-md': {
					[globalTheme.breakpoints.down('lg')]: {
						display: 'none !important',
					},
				},
				'& .d-none-lg': {
					[globalTheme.breakpoints.down('xl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-xl': {
					[globalTheme.breakpoints.down('xxl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-xxl': {
					[globalTheme.breakpoints.down('xxl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-xs': {
					[globalTheme.breakpoints.between('xs', 'xsm')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-xsm': {
					[globalTheme.breakpoints.between('xsm', 'sm')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-sm': {
					[globalTheme.breakpoints.between('sm', 'md')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-md': {
					[globalTheme.breakpoints.between('md', 'lg')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-lg': {
					[globalTheme.breakpoints.between('lg', 'xl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-xl': {
					[globalTheme.breakpoints.between('xl', 'xxl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-xxl': {
					[globalTheme.breakpoints.up('xxl')]: {
						display: 'none !important',
					},
				},
				'.align-center': {
					textAlign: 'center',
					'&-m': {
						textAlign: 'left',
						[`@media screen and (max-width: ${globalTheme.breakpoints.values.md - 1}px)`]: {
							textAlign: 'center',
						},
					},
					'&-d': {
						textAlign: 'left',
						[`@media screen and (min-width: ${globalTheme.breakpoints.values.md}px)`]: {
							textAlign: 'center',
						},
					},
				},
				'.scroll-padding .swiper-container:first-of-type': {
					margin: '0 calc(var(--scroll-padding) / -10)',
					padding: '0 var(--scroll-padding)',
					scrollPadding: '0 var(--scroll-padding)',
				},
			},
		},
	},
}

export default CssBaseline
